import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import DropdownListItem from '../../shared/styledComponents/DropdownListItem';

export default InjectedStyledComponent(DropdownListItem, 'iconDropdown', ['listItem']);